export const NETWORK_ERR = 'NETWORK_ERR'
export const AUTHENTICATED_ERR = 'AUTHENTICATED_ERR'
export const SYSTEM_ERR = 'SYSTEM_ERR'
export const LOGOUT_BY_TIMEOUT = 'LOGOUT_BY_TIMEOUT'

export const POP_NOTIFY = 'POP_NOTIFY'